import React from "react";
import Select from "react-select";

import Modal from "./modal";

const SELECT_STYLES = {
  // The menu is portalled outside the modal, so it needs a higher stacking
  // level than Bootstrap's modal and backdrop layers.
  menuPortal: (base) => ({...base, zIndex: 9999}),
};

/**
 * Lets an administrator choose the one tenant role used for new users.
 * Privileged roles are removed by the page and validated again by the API.
 */
const RoleSettingsModal = ({
  data,
  roles,
  selectedRoleId,
  setSelectedRoleId,
  save,
  cancel,
  saving,
  error,
}) => {
  const options = roles.map((role) => ({
    value: role._id?.$oid || role._id,
    label: role.name,
  }));
  const selectedOption = options.find((option) => option.value === selectedRoleId) || null;

  return (
    <Modal
      title={data.t.read("roles.settings_title")}
      okAction={save}
      okText={data.t.read("save")}
      cancelAction={cancel}
      cancelText={data.t.read("cancel")}
      invalid={!selectedRoleId || saving}
      noProcessingLoading
    >
      <section>
        <h5>{data.t.read("roles.default_role_label")}</h5>
        <p>{data.t.read("roles.default_role_description")}</p>
        <label htmlFor="default-role-select">
          {data.t.read("roles.default_role_label")}
        </label>
        <Select
          inputId="default-role-select"
          aria-label={data.t.read("roles.default_role_label")}
          menuPortalTarget={document.body}
          styles={SELECT_STYLES}
          options={options}
          value={selectedOption}
          onChange={(option) => setSelectedRoleId(option?.value || null)}
          placeholder={data.t.read("roles.default_role_placeholder")}
          isDisabled={saving}
        />
        {error && <p role="alert" className="text-danger mt-2">{error}</p>}
      </section>
    </Modal>
  );
};

export default RoleSettingsModal;
